import numeral from 'numeral';
import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { PriceCurrency } from 'pricing/enums';

interface IProps {
  amount: string | number;
  format?: string;
  currency?: string | boolean;
  thousandSeparator?: boolean;
  decimals?: number;
  placeholder?: string;
  smallDecimals?: number;
  bigDecimals?: number;
  style?: CSSProperties;
}

const DEFAULT_PRICING_DECIMALS = 5;
const DEFAULT_SMALL_PRICING_DECIMALS = 5;
const DEFAULT_BIG_PRICING_DECIMALS = 2;

const getDecimalsToDisplay = (
  amount: number,
  decimals: number,
  smallDecimals: number,
  bigDecimals: number
) => {
  if (amount < 1) {
    return smallDecimals;
  }

  if (decimals === undefined || decimals === null) {
    return amount >= 10 ? bigDecimals : DEFAULT_PRICING_DECIMALS;
  }

  return decimals;
};

const getFormat = (thousandSeparator: boolean, decimals: number, format?: string) => {
  if (format) {
    return format;
  }

  let decimalFormat = `${Array(Math.min(decimals, 2) + 1).join('0')}`;
  if (decimals > 2) {
    decimalFormat += `[${Array(decimals - 1).join('0')}]`;
  }

  return `${thousandSeparator ? '0,0' : ''}0.${decimalFormat}`;
};

const getCurrencyFormat = (currency: string | boolean) => {
  if (currency === false) {
    return '';
  }

  return currency;
};

type WrapperProps = { style?: CSSProperties; children?: ReactNode };

const Wrapper = styled.span<WrapperProps>`
  ${({ style }) => (style ? css(style as any) : undefined)}
`;

/** @deprecated */
const Price = ({
  amount,
  format,
  currency = PriceCurrency.USD,
  thousandSeparator = true,
  decimals,
  placeholder = '-',
  smallDecimals = DEFAULT_SMALL_PRICING_DECIMALS,
  bigDecimals = DEFAULT_BIG_PRICING_DECIMALS,
  style,
}: IProps) => {
  if (amount === undefined || amount === null || isNaN(Number(amount))) {
    return <span>{placeholder}</span>;
  }

  const formattedPrice = numeral(amount).format(
    `${getCurrencyFormat(currency)}${getFormat(
      thousandSeparator,
      getDecimalsToDisplay(Number(amount), decimals, smallDecimals, bigDecimals),
      format
    )}`
  );

  return <Wrapper style={style}>{formattedPrice}</Wrapper>;
};

export default Price;
